import { render, staticRenderFns } from "./chatroom-user.vue?vue&type=template&id=e53b080a&scoped=true"
import script from "./chatroom-user.vue?vue&type=script&lang=js"
export * from "./chatroom-user.vue?vue&type=script&lang=js"
import style0 from "./chatroom-user.vue?vue&type=style&index=0&id=e53b080a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53b080a",
  null
  
)

export default component.exports